import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneForDisplay } from './phone-number.utils';

/**
 * Formats phone numbers for display with libphonenumber-js, falling back to a
 * readable grouped format for unusual numbers the library cannot classify.
 */
@Pipe({
  name: 'phoneFormat',
  standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatPhoneForDisplay(value);
  }
}
